import { call, put } from 'redux-saga/effects';
import {
  fetchTaxRatesByCountryFailure,
  fetchTaxRatesByCountrySuccess,
} from '../actions';
import { getTaxRatesByCountry } from '../api';
import { FetchTaxRatesByCountryRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { TaxRate } from 'store/returns/models/returnData';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchTaxRatesByCountrySaga(
  action: FetchTaxRatesByCountryRequestAction
) {
  try {
    let err: ApiError | null;
    const { countryId } = action.payload;
    const response = yield call(getTaxRatesByCountry, countryId);
    const taxRates: TaxRate[] = response.data.taxRates;

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(fetchTaxRatesByCountrySuccess(taxRates, countryId));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchTaxRatesByCountryFailure());
  }
}
